import * as Yup from 'yup';
import {useTranslation} from "react-i18next";

export const useEmailValidation = ()=>{
    const {t} = useTranslation('common');

    return Yup.string().email(t('errors.email')).trim();
}